import { Alert } from "@mui/material";
import { isNil } from "lodash";
import type React from "react";
import { type ScannedOrderResultAdminDetailQuery } from "../../../generated/graphql";
import ExemplarPanel from "../../ingestion-adhoc-preview/exemplar-panel";

type Exemplar = NonNullable<
  ScannedOrderResultAdminDetailQuery["scannedOrderResultForAdmin"]
>["exemplars"][number];

/** Raw `<object>` element style (not a MUI sx target). */
const documentStyle: React.CSSProperties = {
  height: "72vh",
  width: "100%",
};

/**
 * The exemplars that informed one production scan's extraction, each drilling
 * into its own source document — the same panel the ad-hoc preview tool renders,
 * reading the marker the extraction recorded instead of a live run's retrieval.
 *
 * The source is a pre-signed S3 URL served straight to an `<object>`, matching
 * how the surrounding dialog renders the scan's own document; the ad-hoc tool's
 * pdf.js viewer is not reused here because it renders bytes it fetches from a
 * backend passthrough route, which no production exemplar has.
 *
 * @param props The component props.
 * @param props.exemplars The result's exemplars, in the backend's rank order.
 */
const LogExemplarPanel = ({
  exemplars,
}: {
  readonly exemplars: readonly Exemplar[];
}) => (
  <ExemplarPanel
    exemplars={exemplars}
    emptyMessage="No exemplars are recorded on this scan."
    renderViewer={(exemplar) =>
      isNil(exemplar.preSignedGetUrl) ? (
        <Alert severity="warning">
          This exemplar&apos;s document could not be resolved in the scan&apos;s
          company. It may have been deleted since the extraction ran.
        </Alert>
      ) : (
        <object data={exemplar.preSignedGetUrl} style={documentStyle}>
          <Alert severity="info">No document preview available.</Alert>
        </object>
      )
    }
  />
);

export default LogExemplarPanel;
